import React from "react";
import discordIcon from "../../assets/icons/socials/discord.svg";
import { useRuntimeConfig } from "../providers/RuntimeConfigContext";
import { getDiscordHelpUrl } from "../../config/appConfig";
import "./DiscordHelp.css";

/**
 * DiscordHelp - Floating help block linking to Discord
 * Always visible in bottom-right corner across the app
 */
const DiscordHelp = () => {
  const { config } = useRuntimeConfig();
  const discordUrl = getDiscordHelpUrl(config) || "";

  const isConfigured = Boolean(
    discordUrl && String(discordUrl).trim().length > 0,
  );

  const content = (
    <img src={discordIcon} alt="Discord" className="discord-help__icon" />
  );

  return (
    <div className="discord-help" aria-live="polite">
      {isConfigured ? (
        <a
          className="discord-help__link"
          href={discordUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join Discord for help (opens in a new tab)"
        >
          {content}
        </a>
      ) : (
        <div
          className="discord-help__link discord-help__link--disabled"
          aria-disabled="true"
          title="Discord link not configured"
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default DiscordHelp;
